(function(){
	'use strict';
	angular.module('app.supplyChain')
	.controller('orders', orders);
	orders.$inject = ['$rootScope', '$scope', '$timeout', '$state', '$location', '$experiments', 'redirectParamsService', 'leanFilterService',
	 'tableRenderService', 'tableService', 'storeService', 'FIRST_VIEW'];

	function orders($rootScope, $scope, $timeout,  $state, $location, $experiments, redirectParamsService, leanFilterService, tableRenderService,
		 tableService, storeService, FIRST_VIEW) {

		var vm = this;
		var unsubscribe;

		var reportSettingsName = 'orders';
		// Extra query params to send to backend in data requests
		var extraParams = [{ 'excelReportName': 'Orders' }];
		var rendererParams = {
			'specificTaskType': 'task'
		};
		// Extra drilldown query params to parse
		var defaultFilters = [{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }];
		var extraFilters = [];
		var pinnedColumns = [];

		$scope.filterService = leanFilterService;

		// Set navigation properties
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.useReactReport = $experiments.isEnabled('react-orders');

		vm.viewType = FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[reportSettingsName] || '';

		vm.showExcel = true;

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Order data';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		init();
		var showCustomerOrderMetadata = showCustomerOrderMetadataFields();

		var columns = [
			{
				'id': 'actionStatus',
				'display': 'Task Status',
				'renderer': tableRenderService.status,
				'width': 100,
				'sort': false
			},
			{
				'id': 'taskCount',
				'display': 'Task Count',
				'width': 100,
				'sort': true
			},
			{
				'id': 'itemCode',
				'display': 'Item Code',
				'width': 200,
				'renderer': tableRenderService.itemCode
			},
			{
				'id': 'itemDescription',
				'display': 'Item Description',
				'width': 200
			},
			{
				'id': 'uom',
				'display': 'UOM',
				'width': 80
			},
			{
				'id': 'orderNumber',
				'display': 'Order Number',
				'width': 100
			},
			{
				'id': 'dueDate',
				'display': 'Due Date',
				'renderer': tableRenderService.dateRenderer,
				'convertTimeZone': true,
				'width': 100
			},
			{
				'id': 'quantityFloat',
				'display': 'Quantity',
				'renderer': tableRenderService.integer,
				'width': 100
			},
			{
				'id': 'orderStatus',
				'display': 'Status',
				'width': 100
			},
			{
				'id': 'orderType',
				'display': 'Type',
				'width': 100
			},
			{
				'id': 'customerName',
				'display': 'Customer Name',
				'width': 200,
				'disabled': !showCustomerOrderMetadata
			},
			{
				'id': 'promiseDate',
				'display': 'Customer Order Promise Date',
				'renderer': tableRenderService.dateRenderer,
				'convertTimeZone': true,
				'width': 250,
				'disabled': !showCustomerOrderMetadata
			},
			{
				'id': 'requestedDate',
				'display': 'Customer Order Requested Date',
				'renderer': tableRenderService.dateRenderer,
				'convertTimeZone': true,
				'width': 250,
				'disabled': !showCustomerOrderMetadata
			}
		];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/OrderReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'dueDate',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			setColumnDefaults: true
		};

		vm.broadcastExcel = broadcastExcel;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.baseReportName = vm.baseReportDisplay;

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {
				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined});
		}

		function showCustomerOrderMetadataFields(){
			var validList = Object.values(globalConfig.user.authFacts).filter(function(item){
				return item.customerNdx === globalConfig.customer.id;
			});
			return validList.some(function(item){
				return item.settings.GenerateClearToBuildFlattenedReqs === '1';
			}) && globalConfig.customer.showCustomerOrderMetadata;
		}

		function init() {
			$scope.filterService.clearFilters();
			leanFilterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
			$scope.filterService.setMasterFilterList([
				$scope.filterService.filterDefinitions['Planner']
			]);
		}
	}
})();

